module.exports = __webpack_public_path__ + "img/left-pointing-magnifying-glass.8d022c7a.svg";